export default "__VITE_ASSET___Wa1lLxl__"